"use client";

import { useSession } from "@/contexts/sessionContext";
import { type Locale, i18n } from "@/i18n/i18n-config";
import { useLocale } from "next-intl";
import { useParams } from "next/navigation";

export const DefaultStoreBasedOnLocale: Record<Locale, string> = {
  de: "de",
  nl: "nl",
  es: "es",
  en: "de",
};

export const useStore = () => {
  const params = useParams();
  const locale = useLocale() as Locale;
  const { user } = useSession();
  const store = params.store as string;
  const currentUserStore = user?.stores?.find((s) => s?.code === store) || {
    countryIso: DefaultStoreBasedOnLocale[locale],
    alternativeLocales: [] as Locale[],
    defaultLocale: locale,
    id: undefined,
    code: undefined,
  };

  return {
    store: currentUserStore.code,
    storeId: currentUserStore.id,
    correlatedMainstore: currentUserStore.countryIso.toLocaleLowerCase(),
    locales: [
      ...currentUserStore.alternativeLocales,
      currentUserStore.defaultLocale,
    ].map((locale) => ({
      value: locale,
      label: i18n.localeLabels[locale],
    })),
  };
};
